import { createThemeResource } from "../components/WorkSpace/ToolBarMenuViews/ThemesMenuView.jsx/hooks/createThemeResource";
import ResourceSearchResult from "../OBJRep/ResourceSearchResult";
import { toDataURL } from "./Utils";

export async function getEncarteThemeSearchResult(token, result) {
  try {
    let resources = result.resources;
    resources = await Promise.all(
      resources.map((f, i) => {
        return createThemeResource(f, token);
      }),
    );
    return ResourceSearchResult(
      resources,
      result.isExactMatch,
      result.currentPage,
      result.hasNextPage,
    );
  } catch (err) {
    console.log(err);
  }
}

export const loadThemePrices = async (theme, token) => {
  if (!theme.mainPrice || !theme.secondaryPrice) {
    return theme;
  }

  try {
    const mainPriceDisplayUrl = await toDataURL(
      theme.mainPrice.location + "/",
      token,
    );
    theme.mainPrice.displayUrl = mainPriceDisplayUrl;

    const secondaryPriceDisplayUrl = await toDataURL(
      theme.secondaryPrice.location + "/",
      token,
    );
    theme.secondaryPrice.displayUrl = secondaryPriceDisplayUrl;
  } catch (err) {
    console.error("Failed to load price resource for theme:", theme.name, err);
    return null;
  }
  return theme;
};
